const FREE = 'free';
const LITE = 'lite';
const GROWTH = 'growth';
const ENTERPRISE = 'enterprise';
const CUSTOM = 'custom';

export { FREE, LITE, GROWTH, ENTERPRISE, CUSTOM };
